export default "__VITE_ASSET__0SqjEu5t__"